<template>
  <el-date-picker
    v-model="value"
    class="datetime-width"
    :picker-options="pickerOptions"
    :clearable="true"
    :editable="false"
    type="datetimerange"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    range-separator="-"
    value-format="yyyy-MM-dd HH:mm:ss"
    :default-time="['00:00:00', '23:59:59']"
    placeholder="选择日期">
  </el-date-picker>
</template>

<script>
import moment from "moment";

export default {
  name: 'jlDatetimePicker',
  data() {
    return {
      value: this.dateValue,
      pickerOptions: {
        disabledDate(time) {
          return moment(time).isAfter(moment().endOf('day'));
        },
        shortcuts: [
          {
            text: '当天',
            onClick(picker) {
              picker.$emit('pick', [
                moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(1, 'month').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(3, 'month').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }]
      }
    }
  },
  watch: {
    value: function (newVal) {
      this.$emit("update:dateValue", newVal);
    },
    dateValue: function (newVal) {
      this.value = newVal
    },
  },
  props: {
    dateValue: {
      type: Array,
      default: []
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datetime-picker/jl-datetime-picker.vue